import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//const baseUrl = process.env.NODE_ENV === 'production' ? 'https://webaruba.com' : 'http://web-main';
const baseUrl = 'https://webaruba.com';
const baseUrlData = 'https://aqi-api.webaruba.com';

import axios from 'axios'

export default new Vuex.Store({
  state: {
    token: null,
    menuOpen: false,
    userData: null,
    company: null
  },
  mutations: {
    SET_USER_OBJECT(state, payload) {
      state.userData = payload;
    },
    SET_MENU_OPEN(state, action) {
      state.menuOpen = action
    },
    LOGOUT(state) {
      state.userData = null;
      localStorage.removeItem('userData');
    }
  },
  actions: {
    //not working
    async LOGOUT({commit, state}){   
      const logoutToken = state.userData.logout_token;
      const token = state.userData.csrf_token;
      return await axios.post(`${baseUrl}/user/logout?_format=json&token=${logoutToken}&csrf_token=${token}`)
      .then((res) => {
          if(res.status == 200)
              commit('LOGOUT');
          else
            return false
      }).catch((error)=>{
          console.log(error);
      });
    },
    async LOGIN(_,body){   
      return await axios.post(`${baseUrl}/user/login?_format=json`, body)
      .then((res) => {
          if(res.status == 200)
              return res.data;
          else
            return false
      }).catch((error)=>{
          console.log(error);
      });
    },
    async GET_USER_ROLE(_,payload){   
      return await axios.get(`${baseUrl}/aqi-api/get-user-roles?uid=${payload.userId}&_format=json`, {
        // headers: {
        //   'X-CSRF-Token': payload.token,
        //   'Content-Type':'application/hal+json'
        // },
        auth: {
          username: payload.name,
          password: payload.pass
        }
      })
      .then((res) => {
          if(res.status == 200)
              return res.data;
          else
            return false
      }).catch((error)=>{
          console.log(error);
      });
    },
    async GET_AQI_DATA(_, type){   
      return await axios.get(`${baseUrlData}/rest/display-aqi-data.php?type=${type}`)
      .then((res) => {
          if(res.status == 200)
              return res.data;
      }).catch((error)=>{
          console.log(error);
      });
    },
    async GET_CHART_DATA(_, type){   
      return await axios.get(`${baseUrlData}/rest/display-aqi-data-chart.php?type=${type}`)
      .then((res) => {
          if(res.status == 200)
              return res.data;
      }).catch((error)=>{
          console.log(error);
      });
    }
  }
})
